



























import { Component, Vue } from 'vue-property-decorator';

import Sidebar from '../components/Sidebar.vue';
import { AssessmentInstance } from '../models';
import { httpGet } from '../utils';

@Component({
  components: {
    Sidebar,
  },
})
export default class AssessmentView extends Vue {
  private isLoading: boolean = true;
  private isError: boolean = false;
  private errorMessage: string = '';
  private assessment: AssessmentInstance | null = null;

  private created() {
    this.isLoading = true;
    const url = `${process.env.VUE_APP_API_HOST}/assessments/${this.$route.params.assessmentId}`;
    httpGet<AssessmentInstance>(url)
      .then((assessment) => {
        this.assessment = assessment;
      }).catch((error) => {
        this.errorMessage = error.message;
        this.isError = true;
      }).then(() => {
        this.isLoading = false;
      });
  }
}
